module.exports = __webpack_public_path__ + "media/images/badges/purebarre/PureBarre-1500-Classes-Active-cf03f389cad6faf6335898015965dda4.png";